// ─────────────────────────────────────────────────────────────────────────────
// src/config/storeConfig.ts
// Capa única de configuración frontend para Solsazón.
// Todos los valores son públicos (no secrets). No usar para API keys ni tokens.
// ─────────────────────────────────────────────────────────────────────────────

export const STORE_CONFIG = {

  // ── Umbrales comerciales ──────────────────────────────────────────────────
  FREE_SHIPPING_THRESHOLD: 35,        // CartDrawer, FreeShippingBar, CampaignBanner, SocialProofStrip
  SHIPPING_COST_DEFAULT: 4.99,        // CartDrawer

  // ── Programa de fidelidad ─────────────────────────────────────────────────
  REFERRAL_POINTS_REFERRER: 200,      // ClubSection
  REFERRAL_POINTS_FRIEND: 100,        // ClubSection
  POINTS_TO_EUR_RATIO: 0.01,          // ClubSection — "1 punto = 0,01€"

  // ── Cupón de bienvenida (provisional hasta que esté en BD) ────────────────
  WELCOME_COUPON_CODE: 'BIENVENIDA15',
  WELCOME_COUPON_DISCOUNT: 15,        // NewsletterSection, ClubSection, CouponBanner, offers/page
  FIRST_ORDER_COUPON_CODE: 'BIENVENIDA15', // Primer pedido — usar este en TopBar y Navbar

  // ── Datos de contacto ─────────────────────────────────────────────────────
  CONTACT_EMAIL: 'info@solsazon.com',
  CONTACT_PHONE: '+34 630 863 847',
  CONTACT_PHONE_SCHEMA: '+34-630-863-847', // formato para JSON-LD
  CONTACT_ADDRESS: 'Almería, España',

  // ── Horarios de atención ──────────────────────────────────────────────────
  HOURS_WEEKDAYS: 'Lunes - Viernes: 9:00 - 18:00',
  HOURS_SATURDAY: 'Sábado: 10:00 - 14:00',
  HOURS_OPEN: '09:00',
  HOURS_CLOSE: '18:00',
  HOURS_SAT_OPEN: '10:00',
  HOURS_SAT_CLOSE: '14:00',

  // ── Redes sociales ────────────────────────────────────────────────────────
  SOCIAL_INSTAGRAM: 'https://www.instagram.com/solsazon',
  SOCIAL_FACEBOOK: 'https://www.facebook.com/solsazon',
  SOCIAL_TWITTER: 'https://x.com/solsazon',
  SOCIAL_PINTEREST: 'https://www.pinterest.com/solsazon',
  SOCIAL_TIKTOK: 'https://www.tiktok.com/@solsazon',
  SOCIAL_YOUTUBE: 'https://www.youtube.com/@solsazon',
  SOCIAL_LINKEDIN: 'https://www.linkedin.com/company/solsazon',
  SOCIAL_WHATSAPP_HANDLE: 'solsazon',

  // Array ordenado para uso en schemas JSON-LD (sameAs)
  SOCIAL_SAME_AS: [
    'https://www.facebook.com/solsazon',
    'https://www.instagram.com/solsazon',
    'https://x.com/solsazon',
    'https://www.youtube.com/@solsazon',
    'https://www.pinterest.com/solsazon',
    'https://www.tiktok.com/@solsazon',
    'https://www.linkedin.com/company/solsazon',
  ],

  // ── Stats de marketing ────────────────────────────────────────────────────
  // Actualizar manualmente cuando cambien — no requieren deploy urgente
  STAT_CUSTOMERS: 1200,               // HeroSection, SocialProofStrip, ClubSection
  STAT_PRODUCTS: 30,                  // HeroSection
  STAT_YEARS: 1,                      // HeroSection — fundada en 2026
  STAT_RATING: '4.8',                // HeroSection, SocialProofStrip
  STAT_REPEAT_RATE: 85,               // SocialProofStrip — "85% repiten"
  STAT_SUBSCRIBERS: 1200,             // NewsletterSection, ClubSection

  // ── Geo / localización ────────────────────────────────────────────────────
  GEO_CITY: 'Almería',
  GEO_REGION: 'Andalucía',
  GEO_COUNTRY: 'España',
  GEO_COUNTRY_CODE: 'ES',
  GEO_POSTAL_CODE: '04001',
  GEO_LAT: 36.834,
  GEO_LNG: -2.4637,

} as const;
